import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import EnquiryEMessage from '../../components/EMessage/EnquiryEMessage';
import '../../assets/styles/components/e-message/e-message.scss';

class EMessage extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="e-message-container">
        <section>
          <EnquiryEMessage />
        </section>
      </div>
    )
  }
}

EMessage.defaultProps = {
}

export default withRouter(connect(

)(EMessage))